export default {
  main: {
    title: '版本验证',
    language: '中文',
    intro:
      '版本验证通过匹配版本间的MD5或SHA256是否一致来判断您安装的TokenPocket是否为正版，请您务必通过官方渠道下载TokenPocket钱包，避免上当受骗。关于如何获取版本的MD5或SHA256，',
    tutorial: '请查看教程 >',
    system: '系统',
    android: '安卓',
    ios: '苹果',
    version: '版本号',
    allVersion: '全部版本',
    appChannel: 'App渠道',
    developer: '开发者',
    allChannel: '全部渠道',
    md5: '版本MD5',
    sha256: '版本SHA256',
    log: '版本日志',
    check: '点击查看',
    versionLog: '版本日志',
    confirm: '确定',
    aboutIOS: '关于iOS版本',
    IOSDesc:
      '由于iOS版本只有App Store一个下载渠道，App只有通过App Store下载的才能正常安装，因此在使用苹果相关设备时，请务必认证App Store唯一下载渠道。',
    IOSDesc_2:
      '2022年10月8日之前在App Store中下载的开发商为: TOKENPOCKET FOUNDATION LTD 是TokenPocket开发的早期版本，也是正版钱包可以正常的使用，后续将暂停更新服务。',
    aboutAndroid: '关于安卓版本',
    androidDesc: '当前TokenPocket提供安卓下载的渠道包括：官网、谷歌商店、三星应用商店、华为应用商店、OPPO应用商店、Vivo应用商店。由于个别应用商店在下载过程中无法获取到apk安装包，因此无法进行MD5或SHA256计算校验！所以，请您在下载的时候，务必核对清楚开发商信息，参照下方！',
    IOSAppName: 'App名称:',
    TPWallet: 'TP Wallet',
    AppIcon: 'App图标:',
    AppDeveloper: '官方开发者:',
    downloadLink: '下载链接:',
    copied: '已复制',
    versionVerification: '版本校验',
  },
  follow: {
    title: '关注我们',
    desc1: 'TokenPocket 客服不会私聊您！',
    desc2:
      '请注意，您即将进入TokenPocket社区，您进入社区可能会有人假冒TokenPocket的工作人员私聊您，请您务必警惕，所有私聊您的都可能是骗子！TokenPocket工作人员不会主动跟您私信！',
    desc3: '知道了，继续前往',
  },
  COMMON: {
    LAYOUT: {
      features: '功能',
      products: '产品',
      buyCryptoFooter: '购买数字资产',
      mobileWallet: '手机钱包',
      mobileWalletDesc: '您的移动端数字资产钱包，支持iOS和Android',
      hardwareWallet: '硬件钱包',
      hardwareWalletDesc: '拥有KeyPal，让您的资产更安全',
      extensionWallet: '插件钱包',
      extensionWalletDesc: '您电脑上更好用的钱包',
      desktop: '桌面端钱包',
      fiveDegrees: '5Degrees',
      versionVerification: '版本校验',
      versionVerificationDesc: '验证你的钱包是否为正版',
      approvalDetector: '授权检测',
      approvalDetectorDesc: '查看和取消授权您已经授权的代币',
      tokenSecurity: '代币安全检测',
      tokenSecurityDesc: '通过合约地址检查代币是否安全',
      keyGenerator: '私钥生成器',
      keyGeneratorDesc: '在多个网络上生成公钥和私钥',
      tokenProfile: '代币信息',
      tokenProfileDesc: '了解代币的全方位信息',
      tokenClaim: '领取空投',
      tokenClaimDesc: '获取您的空投',
      easyInscription: '铭文助手',
      easyInscriptionDesc: '安全的铭文铸造工具',
      nostrAssetsBatchSender: 'Nostr批量转账',
      nostrAssetsBatchSenderDesc: 'Nostr资产的批量发送工具',
      BATCH_SENDER: '批量转账',
      BATCH_SENDER_DESC: '一次性向多个接收者批量发送代币',
  
      trade: '交易',
      swap: '闪兑',
      swapDesc: '用最优价格交易',
      bridge: '跨链桥',
      bridgeDesc: '在不同公链之间无缝衔接资产',
      buyCrypto: '购买代币',
      buyCryptoDesc: '用信用卡购买数字资产',
      market: '市场',
      marketDesc: '实时洞察，发现热门代币',
  
      information: '信息',
      blockchainGuide: '区块链小白书',
      tronWallet: '波场小白书',
      iostWallet: 'IOST小白书',
      tpMan: 'TP侠',
  
      developers: '开发者资源',
      github: 'Github (TP-Lab)',
      devCenter: '开发者中心',
      developersDesc: 'TokenPocket的开发者文档',
      subToken: '提交代币',
      subTokenDesc: '提交您的数字资产',
      subDApp: '提交DApp',
      subDAppDesc: '提交您的DApp，我们将在审核后展示它',
      subNFT: '提交NFT',
      subNFTDesc: '提交您的NFT和艺术品',
      subChain: '提交公链',
      subChainDesc: '提交您的区块链',
      bugBounty: '漏洞赏金',
  
      tools: '工具',
  
      build: '开发者中心',
  
      learn: '学习',
  
      explorer: '探索',
  
      company: '公司',
      about: '关于',
      careers: '招聘',
      pressKit: '品牌素材',
      swagShop: '周边商店',
  
      support: '支持',
      helpCenter: '帮助中心',
      helpCenterDesc: '答疑解惑与获取资源的首选',
      contactUs: '联系我们',
      contactUsDesc: '分享您对TokenPocket的任何建议，提出您的任何疑问',
      forum: '社区论坛',
      forumDesc: '祝您与社区成员会谈愉快',
  
      legal: '法律',
      privacyPolicy: '隐私策略',
      terms: '服务协议',

      toHome: '返回首页',
      defiWallet: 'DeFi钱包',
      ETHWallet: '以太坊錢包',
      ethWallet: 'ETH钱包',

      dappStore: 'DApp 商店'
    }
  }
};
